<template>
  <div class="vhp-menu" :id="id">
    <div class="act-btn" @click="isActive = !isActive">
      <slot v-if="$slots.activator" name="activator" />
      <div v-else class="vhp-button round">
        <img src="@/assets/image/menu2.svg" width="16" height="16"/>
      </div>
    </div>

    <div v-show="isActive" class="menus" :class="position" :style="menuStyle">
      <slot v-if="$slots.body" name="body" v-bind:items="items" v-bind:close="close" />
      <div v-else class="menu" v-for="(item, index) in items" :key="index">
        <button @click="item.event()">{{item.title}}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    items: {
      type: Object,
      required: true,
    },
    id: {
      type: String,
      required: true
    },
    isActiveProp: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: 'bottom',
    },

    // STYLE
    width: {
      type: [String, Number],
      default: 'auto'
    },
    height: {
      type: [String, Number],
      default: 'auto'
    },
  },
  data() {
    return {
      isActive: false,
    }
  },
  computed: {
    menuStyle(){
      return {
        width: this.width === 'auto' ? 'auto' : this.width + 'px',
        height: this.height === 'auto' ? 'auto' : this.height + 'px',
      }
    }
  },
  methods: {
    setClickOutsideEvent(){
      window.addEventListener('click', e => {
        const menu = document.querySelector(`#${this.id}`)
        
        if (menu && !menu.contains(e.target)){
          this.isActive = false
        } 
      });
    },
    close(){
      this.isActive = false
    }
  },
  mounted() {
    if(this.isActiveProp){
      this.isActive = this.isActiveProp
    }

    this.setClickOutsideEvent()
  },
}
</script>

<style lang="scss" src="./vhpMenu.scss"></style>